import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { ThemeProvider } from "./contexts/ThemeContext";
import { DataProvider } from "./contexts/DataContext";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
	<React.StrictMode>
		<HelmetProvider>
			<ThemeProvider>
				<DataProvider>
					<BrowserRouter>
						<App />
					</BrowserRouter>
				</DataProvider>
			</ThemeProvider>
		</HelmetProvider>
	</React.StrictMode>
);

reportWebVitals();
